import {
    GetActiveManagementRequestParams,
    IntervalReportSettings,
    useFiltersStore,
} from '@/hooks'
import { ActiveManagementFiltersValues } from '@/utils/constants'
import { useMemo } from 'react'
import { mapActiveManagementFiltersGetParams } from '../utils/mapActiveManagementFiltersGetParams'

export const useActiveManagementFiltersGetParams = (
    activeFilters: ActiveManagementFiltersValues,
    reportSettings?: IntervalReportSettings
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    const hasReportSettings = !!reportSettings
    const timezone = reportSettings?.timezone
    const display = reportSettings?.display
    const dataType = reportSettings?.dataType
    const dataGrouping = reportSettings?.dataGrouping
    const timeInterval = reportSettings?.timeInterval

    const apiRelevantSettings = useMemo(() => {
        if (!hasReportSettings) return null
        return { timezone, display, dataType, dataGrouping, timeInterval }
    }, [
        hasReportSettings,
        timezone,
        display,
        dataType,
        dataGrouping,
        timeInterval,
    ])

    return useMemo(() => {
        const passedFilters = Object.assign({}, activeFilters)

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        const activeManagementFiltersParams =
            mapActiveManagementFiltersGetParams(passedFilters)

        if (!apiRelevantSettings) {
            return activeManagementFiltersParams
        }

        return {
            ...activeManagementFiltersParams,
            timezone: apiRelevantSettings.timezone,
            type:
                apiRelevantSettings.display === 'subMeters'
                    ? 'subMeterData'
                    : 'utilityData',
            dataType: apiRelevantSettings.dataType,
            dataGrouping: apiRelevantSettings.dataGrouping,
            timeInterval: apiRelevantSettings.timeInterval,
            sortOrder: 'asc' as const,
        } as Partial<GetActiveManagementRequestParams>
    }, [activeFilters, apiRelevantSettings, rootNode])
}
